<template>
  <base-section id="map" space="0">
    <vue-friendly-iframe
      class="map-frame"
      className="map-frame"
      :src="url_big"
    ></vue-friendly-iframe>
  </base-section>
</template>

<script>
export default {
  name: "SectionMap",

  provide: {
    heading: { align: "center" },
  },
  data: () => ({
    url:
      "https://www.openstreetmap.org/export/embed.html?bbox=16.774277687072757%2C52.37811421553945%2C16.845946311950687%2C52.40307344797439&amp;layer=mapnik&amp;marker=52.39059559597866%2C16.81011199951172",
    url_big:
      "https://www.openstreetmap.org/export/embed.html?bbox=16.66711807250977%2C52.340373590787394%2C16.953792572021488%2C52.44021115065225&amp;layer=mapnik&amp;marker=52.39032059833382%2C16.810455322265625",
  }),
};
</script>
<style lang="scss">

#map:hover {
  filter: contrast(105%) grayscale(0%);
}

#map:active{
  .map-frame {
    pointer-events: all;
  }
}

#map{
  height: 500px;
  width: 100%;
  transition: 500ms;
  filter: contrast(100%) grayscale(15%);

  .map-frame {
    user-select: none;
    height: 500px;
    width: 100%;
    pointer-events: none;
  }
}
</style>